<template>
  <div class="tab-navigation" :style="`--total-grid: ${tabs.length}`">
    <div
        v-for="tab of tabs"
        class="tab-navigation-btn"
        :class="{ active: currentTab === tab.key }"
        role="button" aria-pressed="false"
        @click="showTab(tab.key)"
    >
      {{ tab.title }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentTab: {
      required: true,
      type: String,
    },
    tabs: {
      required: true,
      type: Array,
    },
  },

  methods: {
    showTab (tabName) {
      this.$emit('tabSelected', tabName);
    },
  },
};
</script>
